
import { controls } from "../controls";


const termdeposit2 = {
  label: "Term Deposite",
  pageLabel: "Term Deposite",
  starting: true,
  url: "termdeposit2",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    {
      widths: "col-sm-6",
      title: "Deposit Details",
      // style: { border: 0, paddingTop: 0 },
      subComponents: [

        ...controls.displayText({ label: "Interest Frequency", width: "col-sm-4" }),
        ...controls.IntFrequency({ width:"col-sm-4" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ width: "col-sm-4", label: "Receipt No" }),
        ...controls.numberOnly({ name: "receipt_no", width: "col-sm-4", placeHolder: "Receipt No" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.magicDateLabel({ width: "col-sm-4", star: true, label: "As on Date" }),
        ...controls.magicDate({ name: "as_on_date", width: "col-sm-4", default: "sessiondate", isRequired: true }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.magicDateLabel({ label: "Renewal Date", width: "col-sm-4" }),
        ...controls.magicDate({ dateType: "ontype", name: "renewal_date", width: "col-sm-4", default: "sessiondate" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "Deposit Amount", width: "col-sm-4" }),
        ...controls.floatOnly({name: "deposit_amount", width: "col-sm-4"
        }),
        ...controls.showData({data:"deposit_amount",displaytype:"in_words", width:"col-sm-4"}),


        ...controls.displayText({ width: "col-sm-4", label: "Deposit Period", star: true }),
        ...controls.displayText({ width: "col-sm-2", label: "Month", }),
        ...controls.numberOnly({ name: "deposit_period_month", width: "col-sm-2", isRequired: true }),
        ...controls.displayText({ label: "Days", width: "col-sm-1" }),
        ...controls.daysinterest({ width: "col-sm-2", isRequired: true }),
        ...controls.displayText({ width: "col-sm-1" }),

        ...controls.displayText({ width: "col-sm-4", label: "Interest Rate" }),
        ...controls.numberOnly({ name: "ints_rate", width: "col-sm-2", isReadOnly: true }),
        ...controls.displayText({ width: "col-sm-6" }),


        ...controls.checkBox({ label: "Auto Renew", name: "isAutorenew", width: "col-sm-6" }),
        ...controls.checkBox({ label: "Auto Renew With interest", name: "isAutorenewInterest", width: "col-sm-6" }),
        ...controls.checkBox({ label: "Senior Citizen", name: "isSeniorCitizen", width: "col-sm-4" }),
        ...controls.checkBox({ label: "Society", name: "isSociety", width: "col-sm-4" }),
        ...controls.checkBox({ label: "Staff", name: "isStaff", width: "col-sm-4" }),
      ]
    },
    {
      widths: "col-sm-6",
      title: "Maturity Details",
      subComponents: [
        ...controls.displayText({ width: "col-sm-4", label: "Maturity Interest Transfer to", }),
        ...controls.text({ name: "maturity_interest_transfer_to", width: "col-sm-4", placeHolder: "Maturity Interest" }),
        ...controls.displayText({ width: "col-sm-4" }),
        
        ...controls.displayText({ width: "col-sm-4", label: "Standing Interest Transfer To" }),
        ...controls.text({ name: "maturity_interest_transfer_to", width: "col-sm-4", placeHolder: "Maturity Interest" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "GL Sub Head", width: "col-sm-4" }),
        ...controls.product({ width: "col-sm-4" }),
        ...controls.showData({ data: "product_code_display", name: "product_code_display", width: "col-sm-4" }),

        ...controls.displayText({ label: "Account Number", width: "col-sm-4" }),
        ...controls.AccountNumber({ tab: "termdeposit2", width: "col-sm-4" }),
        ...controls.showData({ data: "account_number_display", name: "account_number_display", width: "col-sm-4" }),

        ...controls.magicDateLabel({ label: "Standing Due Date", width: "col-sm-4" }),
        ...controls.magicDate({ dateType: "ontype", name: "std_duedate", width: "col-sm-4" }),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "Maturity Date", width: "col-sm-4" }),
        ...controls.showData({
          displaytype: 'date', data: "maturity_date", name: "maturity_date", width: "col-sm-4"}),
        ...controls.displayText({ width: "col-sm-4" }),

        ...controls.displayText({ label: "Total Interest", width: "col-sm-4" }),
        ...controls.showData({ data: "maturity_total",displaytype:"currency", width: "col-sm-4"}),
        ...controls.showData({data:"maturity_total",displaytype:"in_words",width:"col-sm-4"}),

        ...controls.displayText({ label: "Maturity Amount", width: "col-sm-4" }),
        ...controls.showData({ data: "maturity_amount_display",displaytype:"currency", width: "col-sm-4"}),
        ...controls.showData({data:"maturity_amount_display",width:"col-sm-4",displaytype:"in_words"}),
      ]
    },
    {
      widths: "col-sm-12",
      tab: "termdeposit2",
      title:"Interest Schedule",
      subComponents: [
        // {
        //   inputType: "button",
        //   tab: "recurringdeposit",
        //   widths: {
        //     parent: "col-sm-6",
        //     children: "col-sm-12"
        //   },
        //   placeHolder: "",
        //   label: "save",
        //   onclick: {
        //     action: "handlesave",
        //     loadinto: "AllData"
        //   },
        //   name: "savechanges",
        //   Bcolor: "primary",
        //   size: "sm",
        //   style:{width:'145px'}
        // },
        {
          inputType: "table",
          tableTitle: "",
          // editable: true,
          // addRows: true,
          printable: true,
          // defaultValue:[{trdate:'',days:'',},{}],
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Date", isRequired: true,  field: "trdate", displaytype: 'date', control: 'branch' },
            { label: "Days", field: "days", control: 'text', displaytype: 'text' },
            { label: "Months", field: "months" },
            { label: "Interest", field: "interest", displaytype: 'currency' },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          description: "Interest Schedule Table",
          name: "intsche",
          // displayData: { ReadIntRate: "ints_rate",GetAddDate:'maturity_date',GenerateInterestSchedule:"intsche_table" },
          onRender: [
            // // sum last column of the current table
            { f: 'tableCalculations', calcType: 'sum', inputs: { source: 'pageData.Deposits.intsche', field: 'interest' }, resultVar: 'totalInterest' },
            { f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'allResults', field: 'totalInterest' }, { source: 'pageData.Deposits.deposit_amount' }], resultVar: 'total' },
            // // and set it as some other parentState.
            { f: 'setParentState', inputs: { dest: "pageData.Deposits.maturity_amount_display", source: 'allResults', field: 'total' }, resultVar: "maturity_amount" },
            { f: 'setParentState', inputs: { dest: "pageData.Deposits.maturity_total", source: 'allResults', field: 'totalInterest' }, resultVar: "maturity_total" },
            { f: 'setParentState', inputs: { dest: "pageData.interest_rate", source: 'pageData.Deposits.ints_rate', }, resultVar: "interest_rate" },

            // { f: 'dateOperations', inputs: [{ source: 'pageData.as_on_date', type: 'date' }, { source: 'pageData.Recurring.no_installments', type: 'months' }], resultVar: "maturity_date" },
            // { f: 'setParentState', inputs: { dest: "pageData.Recurring.maturity_date", source: 'allResults',field:'maturity_date' }, resultVar: "xyz" },

            // { f: 'setParentState', inputs: { dest:"pageData.Deposits.maturity_amount_display", source:'allResults',field: 'total', conditions:[{result:{type:"fixed",val:""},check:"neq", }] },resultVar:"maturity_amount" },
          ]
        },
        
      ]
    },
  ]
}

export default termdeposit2;